// eslint-disable-next-line boundaries/no-unknown-files
import { createApi } from '@reduxjs/toolkit/query/react';
// eslint-disable-next-line boundaries/element-types
import createHeadRequest from '../../../../shared/http/createHeadRequest';
// eslint-disable-next-line boundaries/element-types
import checkStatus from '../../../../shared/http/checkStatus';
// eslint-disable-next-line boundaries/element-types
import HttpMethods from '../../../../shared/api/HttpMethods';
// eslint-disable-next-line boundaries/element-types
import config from '../../../../shared/api/config';
import reducerPath from '../../../../app/reducerPath';
// eslint-disable-next-line boundaries/element-types
import baseQueryWithReAuth from '../../../baseQueryWithReAuth/baseQueryWithReAuth';

const CUSTOM_AUGMENTATION = 'CUSTOM_AUGMENTATION';

// Описываем методы обращения к беку
export const customAugmentationApi = createApi({
  reducerPath: `${reducerPath.customAugmentation}/api`,
  tagTypes: [CUSTOM_AUGMENTATION],
  baseQuery: (...arg) => baseQueryWithReAuth(...arg, `${config.baseUrl}`),
  endpoints: (builder) => ({
    getCustomAugmentations: builder.query({
      query: () => ({
        ...createHeadRequest({
          url: '/custom-augmentations', method: HttpMethods.GET
        }),
        validateStatus: checkStatus,
      }),
    }),
    getCustomAugmentationsById: builder.query({
      query: ({
        id
      }) => ({
        ...createHeadRequest({
          url: `/custom-augmentations/${id}`, method: HttpMethods.GET
        }),
        validateStatus: checkStatus,
      }),
      providesTags: [CUSTOM_AUGMENTATION],
    }),
    patchCustomAugmentations: builder.mutation({
      query: ({
        id,
        body,
      }) => ({
        ...createHeadRequest({
          url: `/custom-augmentations/${id}`, method: HttpMethods.PATCH
        }),
        body,
        validateStatus: checkStatus,
      }),
      invalidatesTags: [CUSTOM_AUGMENTATION],
    }),
    getCustomAugmentationAttrs: builder.query({
      query: () => ({
        ...createHeadRequest({
          url: '/custom-augmentation-attrs', method: HttpMethods.GET
        }),
        validateStatus: checkStatus,
      }),
    }),
    getCustomAugmentationAttrsById: builder.query({
      query: ({
        id
      }) => ({
        ...createHeadRequest({
          url: `/custom-augmentation-attrs/${id}`, method: HttpMethods.GET
        }),
        validateStatus: checkStatus,
      }),
    }),
    postCustomAugmentationAttrs: builder.mutation({
      query: ({
        body,
      }) => ({
        ...createHeadRequest({
          url: '/custom-augmentation-attrs', method: HttpMethods.POST,
        }),
        body,
        validateStatus: checkStatus,
      }),
      invalidatesTags: [CUSTOM_AUGMENTATION],
    }),
    patchCustomAugmentationAttrs: builder.mutation({
      query: ({
        id,
        body,
      }) => ({
        ...createHeadRequest({
          url: `/custom-augmentation-attrs/${id}`, method: HttpMethods.PATCH,
        }),
        body,
        validateStatus: checkStatus,
      }),
    }),
    invalidatesTags: [CUSTOM_AUGMENTATION],
  }),
});

export const {
  useLazyGetCustomAugmentationsQuery,
  useLazyGetCustomAugmentationsByIdQuery,
  usePatchCustomAugmentationsMutation,
  useGetCustomAugmentationAttrsQuery,
  useGetCustomAugmentationAttrsByIdQuery,
  usePostCustomAugmentationAttrsMutation,
  usePatchCustomAugmentationAttrsMutation,
} = customAugmentationApi;
